<template>
  <div class="tw-text-neutral-900 tw-font-bold tw-text-2xl tw-leading-none">
    <slot />
  </div>
</template>
